import type { RouteLocationRaw } from 'vue-router'
import urlJoin from 'url-join'
import QueryEnum from '~/enums/QueryEnum'

export default (
  productSlug?: string | string[],
  productVariant?: ProductVariant,
  locale?: Locale
): RouteLocationRaw => {
  const newLocale = locale ?? useState<string>('locale.setting').value

  const prefixBase = []

  if (newLocale) {
    prefixBase.push(`/${newLocale}`)
  }

  if (!productSlug || productSlug === '/') {
    return {
      path: urlJoin([...prefixBase, '/']),
    }
  }

  const base = [...prefixBase, '/p']

  return {
    path: urlJoin(base.concat(productSlug ?? '')),
    query: {
      [QueryEnum.ProductVariant]: productVariant ?? null,
    },
  }
}

type ProductVariant = number | null | undefined
type Locale = string | null | undefined
